import { fetchDataAndProceed } from '../../config/utils'
import { METHOD_TYPES } from '../../config/constants'

export const getApilogsList = (data, callback) => {
  return fetchDataAndProceed('/admin/v1/fetchApiResponses', METHOD_TYPES.GET, data, callback)
}

export const getApiLogDetails = (data, callback) => {
  return fetchDataAndProceed("/admin/v1/fetchApiResponses", METHOD_TYPES.GET, data, callback)
}



// WEBPACK FOOTER //
// ./src/data/redux/apilogs_details/api.js